import defaults from 'hs-lodash/defaults';

/**
 * Do not use externally
 */

const propertyBase = {
  name: null,
  label: null,
  description: null,
  groupName: null,
  type: 'string',
  fieldType: 'text',
  formField: true,
  displayOrder: 0,
  readOnlyValue: false,
  readOnlyDefinition: true,
  hidden: false,
  mutableDefinitionNotDeletable: true,
  favorited: false,
  favoritedOrder: 0,
  calculated: false,
  externalOptions: false,
  displayMode: 'current_value',
  options: []
};
const properties = [{
  name: 'engagement.timestamp',
  label: 'Due date',
  type: 'datetime'
}, {
  name: 'engagement.ownerId',
  label: 'Assigned to',
  type: 'enumeration'
}, {
  name: 'engagement.createdBy',
  label: 'Created by',
  type: 'enumeration',
  hidden: true
}, {
  name: 'engagement.type',
  label: 'Type',
  type: 'enumeration',
  hidden: true,
  options: [{
    label: 'Email',
    value: 'EMAIL'
  }, {
    label: 'Call',
    value: 'CALL'
  }, {
    label: 'Meeting',
    value: 'MEETING',
    hidden: true
  }, {
    label: 'Task',
    value: 'TASK',
    hidden: true
  }, {
    label: 'Note',
    value: 'NOTE',
    hidden: true
  }, {
    label: 'To-do',
    value: 'TODO'
  }]
}, {
  name: 'metadata.body',
  label: 'Task',
  filterName: 'task.body',
  hidden: false
}, {
  name: 'metadata.status',
  label: 'Status',
  filterName: 'task.status',
  type: 'enumeration',
  options: [{
    label: 'Not Started',
    value: 'NOT_STARTED'
  }, {
    label: 'In Progress',
    value: 'IN_PROGRESS'
  }, {
    label: 'Waiting',
    value: 'WAITING'
  }, {
    label: 'Completed',
    value: 'COMPLETED'
  }, {
    label: 'Deferred',
    value: 'DEFERRED'
  }]
}];
properties.forEach(property => defaults(property, propertyBase));
export default properties;